import PropTypes from 'prop-types'
import { ItemsPageContainer, RightContainer } from '../styled-components.js'

const ToolbarRightContainer = ({ children }) => {
  return (
    <RightContainer>
      <ItemsPageContainer>{children}</ItemsPageContainer>
    </RightContainer>
  )
}

ToolbarRightContainer.propTypes = {
  children: PropTypes.node.isRequired
}

export default ToolbarRightContainer
